
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full text-center space-y-6">
        <h1 className="text-6xl font-bold text-foreground">404</h1>
        <p className="text-xl text-muted-foreground">This page doesn't exist</p>
        <div className="border-t border-border w-16 mx-auto my-6"></div>
        <p className="text-base text-muted-foreground">
          The page you're looking for may have been moved, deleted, or never existed.
        </p>
        <Button asChild className="mt-6">
          <Link to="/" className="inline-flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Return to home
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;